<template>
  <div class="main_container">
    <el-container>
      <!-- 侧边栏 -->
      <el-aside width="200px">
        <el-menu router :default-active="activeIndex">
          <el-menu-item
            :index="item.html"
            v-for="(item, index) in twoPermissionsMenu"
            :key="index"
            @click="setItemPath(item.html)"
          >
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { userpermissionsall, userpermissions } from '@/api/home'
export default {
  data() {
    return {
      // 二级菜单
      token: localStorage.getItem('token'),
      twoPermissionsMenu: [],
      // 处理默认高亮
      activeIndex: '',
      roleId: '',
    }
  },
  created() {
    // this.userpermissionsall()
    this.userpermissions()
    // 初始化时取出保存的页面路径
    this.setItemPath()
    this.activeIndex = window.sessionStorage.getItem('activeIndex')
  },
  methods: {
    //根据角色查询权限菜单

    async userpermissions() {
      this.roleId = localStorage.getItem('roleId')
      const { data: res } = await userpermissions({
        appCode: 'JCSJGL',
        roleId: this.roleId,
      })
      this.twoPermissionsMenu = res.data[0].menuList
    },
    // //  调用权限列表接口
    // async userpermissionsall() {
    //   const { data: res } = await userpermissionsall({
    //     appCode: 'JCSJGL',
    //     parentId: 0,
    //   })
    //   // console.log(res);
    //   this.twoPermissionsMenu = res.data[0].menuList
    // },
    // 处理默认高亮
    setItemPath(activeIndex) {
      const path = this.$route.path
      if (!activeIndex) {
        let timeur = setTimeout(() => {
          const roleType = localStorage.getItem('roleType')
          // console.log('roleType', roleType)
          if (this.roleId == '-1003') {
            // window.sessionStorage.setItem('activeIndex','/school/classes')
            this.activeIndex = '/school/classes'
          }
        }, 1000)
      }
      if (this.roleId == '-1003') {
        window.sessionStorage.setItem('activeIndex',activeIndex)
        // this.activeIndex = '/school/classes'
      }

      if (path == '/school/info') {
        window.sessionStorage.setItem('activeIndex', '/school/info')
      }
      this.activeIndex = activeIndex
      window.sessionStorage.setItem('activeIndex', path)
    },
  },
}
</script>
<style scoped>
.main_container {
  height: 100%;
}

.el-container {
  height: 100%;
  background-color: #f7f7f7;
}

.el-aside {
  width: 200px;
  background-color: #fff;
  margin-right: 10px;
  padding-top: 30px;
}
.el-menu-item span {
  font-size: 14px;
}
.el-menu-item {
  text-align: center;
}

.el-main {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/school/index.vue